import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/GetStaticMap'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class GetStaticMapStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "GetStaticMapStore",
			variables: true,
		})
	}
}

export async function load_GetStaticMap(params) {
  await initClient()

	const store = new GetStaticMapStore()

	await store.fetch(params)

	return {
		GetStaticMap: store,
	}
}
